import type {
  FindApplicationsRequestFilter,
  FindApplicationsRequestSort,
} from '~domains/commerce/transactions/entities/application';

import type { DataTableSorting } from '~shared/ui/data-table';

import { endOfDay, startOfDay } from 'date-fns';

import { ColumnId } from './columns';

import type { ApplicationsFiltersValue } from '../model/applications-filters';

type SortableColumn = Exclude<ColumnId, ColumnId.POS>;

const COLUMN_TO_SORT_KEY: Record<
  SortableColumn,
  FindApplicationsRequestSort['key']
> = {
  [ColumnId.AGREEMENT_ID]: 'agreementId',
  [ColumnId.STATUS]: 'applicationStatus',
  [ColumnId.DATE]: 'applicationTimestampUTC',
  [ColumnId.SALE_AMOUNT]: 'saleAmount',
  [ColumnId.DOWN_PAYMENT]: 'downPaymentAmount',
  [ColumnId.FINANCED_AMOUNT]: 'financedAmount',
};

export function sortToParams(
  sorting: DataTableSorting | undefined
): FindApplicationsRequestSort | undefined {
  if (!sorting) return undefined;

  const key = COLUMN_TO_SORT_KEY[sorting.id as SortableColumn];
  if (!key) return undefined;

  return { key, order: sorting.direction === 'asc' ? 'ASC' : 'DESC' };
}

export function filtersToParams({
  period,
  posIds,
  merchantIds,
  statuses,
}: ApplicationsFiltersValue): FindApplicationsRequestFilter {
  const { startDate, endDate } = period ?? {};
  const dateTo = endDate ? new Date(endDate) : new Date();
  const dateFrom = startDate ? new Date(startDate) : new Date();

  return {
    dateTo: endOfDay(dateTo).toISOString(),
    dateFrom: startOfDay(dateFrom).toISOString(),
    merchantIds,
    pointOfSaleIds: posIds,
    applicationStatuses: statuses,
  };
}
